import React from 'react'
import classnames from 'classnames'

const Search: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <svg
      className={classnames('search-icon', {
        [className]: !!className,
      })}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="5.39345"
        cy="5.39346"
        rx="4.39345"
        ry="4.39346"
        stroke="currentColor"
        strokeLinejoin="bevel"
        fill="none"
      />
      <line
        y1="-0.5"
        x2="3.29509"
        y2="-0.5"
        transform="matrix(0.707106 0.707108 -0.707106 0.707108 8.11218 8.62177)"
        stroke="currentColor"
        strokeLinejoin="bevel"
      />
      <rect
        width="2.19673"
        height="6.59018"
        transform="matrix(0.707106 -0.707108 0.707106 0.707108 9.78723 11.34)"
        stroke="currentColor"
        strokeLinejoin="bevel"
        fill="none"
      />
    </svg>
  )
}

export default Search
